// Subscriber web brief layout tokens.
// Edit styles here (and in src/components/brief/*) — email HTML is separate
// (api/lib/emailTemplate.js) and is not updated when you change the web brief.

/** Full width within the page shell (max-w-page ≈ 1100px). */
export const BRIEF_SHELL = 'w-full';

/** Desktop sidebar scroll — styled in index.css (.brief-sidebar-scroll). */
export const BRIEF_SIDEBAR_SCROLL = 'brief-sidebar-scroll';
